var _defs, _g, _g2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignElement2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10168",
    "data-name": "Group 10168",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5653",
    "data-name": "Rectangle 5653",
    width: 492,
    height: 191.412,
    fill: "#31e5e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10166",
    "data-name": "Group 10166"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5681",
    "data-name": "Rectangle 5681",
    width: 512,
    height: 512,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10075",
    "data-name": "Group 10075",
    transform: "translate(10 160)",
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10074",
    "data-name": "Group 10074",
    transform: "translate(0 0)",
    opacity: 0.26,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6964",
    "data-name": "Path 6964",
    d: "M55.676,27.85A27.838,27.838,0,1,1,27.842,0,27.84,27.84,0,0,1,55.676,27.85",
    transform: "translate(0 -0.003)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6965",
    "data-name": "Path 6965",
    d: "M72.2,27.85A27.838,27.838,0,1,1,44.37,0,27.84,27.84,0,0,1,72.2,27.85",
    transform: "translate(128.913 -0.003)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6966",
    "data-name": "Path 6966",
    d: "M88.732,27.85A27.838,27.838,0,1,1,60.9,0,27.84,27.84,0,0,1,88.732,27.85",
    transform: "translate(257.827 -0.003)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6967",
    "data-name": "Path 6967",
    d: "M105.26,27.85A27.838,27.838,0,1,1,77.426,0,27.84,27.84,0,0,1,105.26,27.85",
    transform: "translate(386.74 -0.003)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6968",
    "data-name": "Path 6968",
    d: "M55.676,43.263a27.838,27.838,0,1,1-27.833-27.85,27.84,27.84,0,0,1,27.833,27.85",
    transform: "translate(0 120.296)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6969",
    "data-name": "Path 6969",
    d: "M72.2,43.263A27.838,27.838,0,1,1,44.37,15.413,27.84,27.84,0,0,1,72.2,43.263",
    transform: "translate(128.913 120.296)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6970",
    "data-name": "Path 6970",
    d: "M88.732,43.263A27.838,27.838,0,1,1,60.9,15.413a27.84,27.84,0,0,1,27.833,27.85",
    transform: "translate(257.827 120.296)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6971",
    "data-name": "Path 6971",
    d: "M105.26,43.263a27.838,27.838,0,1,1-27.833-27.85,27.84,27.84,0,0,1,27.833,27.85",
    transform: "translate(386.74 120.296)",
    fill: "#31e5e5"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5682",
    "data-name": "Rectangle 5682",
    width: 512,
    height: 512,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignElement2);
export default __webpack_public_path__ + "static/media/designElement2.be014e6a07fe4f011cb78feb7371518a.svg";
export { ForwardRef as ReactComponent };